export default __webpack_public_path__ + "static/media/PLAIN_CINDER_120x278_01_265.27ad3363.jpg";